import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

const GROUPS = [
  {
    title: "Simple Logo — Peony (Icon B)",
    note: "Your everyday mark. Avatars, tags, stamps.",
    items: [
      { src: "/brand/logo-icon-dark.png", label: "Icon — white on black", meta: "1024px master" },
      { src: "/brand/logo-icon-light.png", label: "Icon — black on white", meta: "1024px master" },
      { src: "/brand/logo-avatar-dark.png", label: "Avatar — dark", meta: "1024px · circle-crop safe" },
      { src: "/brand/logo-avatar-light.png", label: "Avatar — light", meta: "1024px · circle-crop safe" },
      { src: "/brand/logo-peony-white.png", label: "Icon — white, transparent", meta: "1024px · overlays", tile: "dark" },
      { src: "/brand/logo-peony-black.png", label: "Icon — black, transparent", meta: "1024px · overlays", tile: "light" },
    ],
  },
  {
    title: "Advertising Lockup — Crest + Wordmark (E1)",
    note: "For posts, ads, and anywhere the name appears.",
    items: [
      { src: "/brand/lockup-E1-dark.png", label: "Lockup — dark", meta: "1600×2300 master" },
      { src: "/brand/lockup-E1-light.png", label: "Lockup — light", meta: "1600×2300 master" },
      { src: "/brand/logo-lockup-square-dark.png", label: "Square ad — dark", meta: "2048×2048 feed" },
      { src: "/brand/logo-lockup-square-light.png", label: "Square ad — light", meta: "2048×2048 feed" },
      { src: "/brand/logo-lockup-story-dark.png", label: "Story ad — dark", meta: "1080×1920" },
      { src: "/brand/logo-lockup-story-light.png", label: "Story ad — light", meta: "1080×1920" },
      { src: "/brand/logo-lockup-wide-dark.png", label: "Wide banner — dark", meta: "2400×1200" },
      { src: "/brand/logo-lockup-wide-light.png", label: "Wide banner — light", meta: "2400×1200" },
      { src: "/brand/logo-crest-white.png", label: "Crest — white, transparent", meta: "1024px · overlays", tile: "dark" },
      { src: "/brand/logo-crest-black.png", label: "Crest — black, transparent", meta: "1024px · overlays", tile: "light" },
    ],
  },
  {
    title: "Posters",
    note: "1600×2000 — feed, print, or storefront.",
    items: [
      { src: "/posters/poster-1.png", label: "Poster 1 — Worn, Not Styled", meta: "black card · back print" },
      { src: "/posters/poster-2.png", label: "Poster 2 — Lucky Seven", meta: "white card · hanger" },
      { src: "/posters/poster-3.png", label: "Poster 3 — Word Search", meta: "black card · hanging tees" },
    ],
  },
  {
    title: "Feed Posts",
    note: "1080×1350 — Instagram feed / TikTok photo mode.",
    items: [
      { src: "/instagram/post-firstdrop-white.png", label: "First Drop — white", meta: "1080×1350" },
      { src: "/instagram/post-firstdrop-black.png", label: "First Drop — black", meta: "1080×1350" },
    ],
  },
  {
    title: "Stories",
    note: "1080×1920 — announcement set.",
    items: [
      { src: "/instagram/story-1-black.png", label: "Story 1 — black", meta: "1080×1920" },
      { src: "/instagram/story-2-white.png", label: "Story 2 — white", meta: "1080×1920" },
      { src: "/instagram/story-3-spec.png", label: "Story 3 — spec sheet", meta: "1080×1920" },
    ],
  },
  {
    title: "Countdowns",
    note: "Post one per day, Aug 31 → Sept 7.",
    items: [
      { src: "/instagram/countdown-7-days.png", label: "7 days", meta: "post Aug 31" },
      { src: "/instagram/countdown-6-days.png", label: "6 days", meta: "post Sept 1" },
      { src: "/instagram/countdown-5-days.png", label: "5 days", meta: "post Sept 2" },
      { src: "/instagram/countdown-4-days.png", label: "4 days", meta: "post Sept 3" },
      { src: "/instagram/countdown-3-days.png", label: "3 days", meta: "post Sept 4" },
      { src: "/instagram/countdown-2-days.png", label: "2 days", meta: "post Sept 5" },
      { src: "/instagram/countdown-1-day.png", label: "1 day", meta: "post Sept 6" },
      { src: "/instagram/countdown-today.png", label: "Today", meta: "Sept 7 morning" },
      { src: "/instagram/countdown-live.png", label: "Live", meta: "Sept 7 · 10 AM PT" },
    ],
  },
  {
    title: "Teasers",
    note: "One per tee — build the week before countdown.",
    items: [
      { src: "/instagram/teaser-citrus-mosaic.png", label: "001 Citrus Mosaic", meta: "1080×1920" },
      { src: "/instagram/teaser-dove.png", label: "002 Dove", meta: "1080×1920" },
      { src: "/instagram/teaser-laurel.png", label: "003 Laurel", meta: "1080×1920" },
      { src: "/instagram/teaser-word-search.png", label: "004 Word Search", meta: "1080×1920" },
      { src: "/instagram/teaser-greek-plate.png", label: "005 Greek Plate", meta: "1080×1920" },
      { src: "/instagram/teaser-lucky-seven.png", label: "006 Lucky Seven", meta: "1080×1920" },
    ],
  },
  {
    title: "Sale — 15% Off Tees (Oct 10–25)",
    note: "1080×1350 — current sale. $70 becomes $59.50.",
    items: [
      { src: "/instagram/sale15-black.png", label: "15% sale — black", meta: "feed post" },
      { src: "/instagram/sale15-white.png", label: "15% sale — white", meta: "feed post" },
    ],
  },
  {
    title: "Drop 002 — Hoodies",
    note: "1080×1350 — waitlist + $5 off first 5 per hoodie.",
    items: [
      { src: "/instagram/drop002-hoodies-white.png", label: "Drop 002 hoodies — white", meta: "feed post" },
      { src: "/instagram/drop002-hoodies-black.png", label: "Drop 002 hoodies — black", meta: "feed post" },
      { src: "/instagram/drop002-story-white.png", label: "Drop 002 story — white", meta: "story · black hoodie hero" },
      { src: "/instagram/drop002-story-black.png", label: "Drop 002 story — black", meta: "story · navy hoodie hero" },
    ],
  },
  {
    title: "Shipped Announcement",
    note: "1080×1350 — post after marking orders shipped.",
    items: [
      { src: "/instagram/shipped-black.png", label: "Shipped — black", meta: "feed post" },
      { src: "/instagram/shipped-white.png", label: "Shipped — white", meta: "feed post" },
    ],
  },
  {
    title: "Lucky Seven — Sales Push",
    note: "1080×1350 — hero + live scarcity numbers (as of Sept 13).",
    items: [
      { src: "/instagram/lucky7-hero.png", label: "Lucky Seven — hero", meta: "feed post" },
      { src: "/instagram/lucky7-stock.png", label: "Lucky Seven — 6 sold · XL only 2 left", meta: "feed post · numbers frozen Sept 13" },
    ],
  },
  {
    title: "Outfit Grids",
    note: "1080×1350 — the flat-lay trend, your tees as the hero.",
    items: [
      { src: "/instagram/outfit-1.png", label: "Outfit 1 — Citrus Mosaic", meta: "black denim · gum soles" },
      { src: "/instagram/outfit-2.png", label: "Outfit 2 — Laurel", meta: "pleated trousers · silver watch" },
      { src: "/instagram/outfit-3.png", label: "Outfit 3 — Lucky Seven", meta: "light-wash denim · cream suede" },
    ],
  },
  {
    title: "Size Chart",
    note: "1080×1920 — answers fit DMs before they happen.",
    items: [
      { src: "/instagram/sizechart-black.png", label: "Size chart — black", meta: "story" },
      { src: "/instagram/sizechart-white.png", label: "Size chart — white", meta: "story" },
    ],
  },
  {
    title: "Sale Cards",
    note: "Sept sale — ended Sept 21. Kept for reference.",
    items: [
      { src: "/instagram/sale-20off-white.png", label: "Sale — white", meta: "1080×1920" },
      { src: "/instagram/sale-20off-black.png", label: "Sale — black", meta: "1080×1920" },
    ],
  },
];

const slug = (s) => s.replace(/[^a-z0-9]+/gi, "-").toLowerCase();

const AssetCard = ({ item }) => (
  <div className="border border-white/15 flex flex-col" data-testid={`asset-card-${slug(item.label)}`}>
    <a href={item.src} target="_blank" rel="noreferrer" className="block">
      <div
        className={`aspect-square flex items-center justify-center overflow-hidden ${
          item.tile === "light" ? "bg-white" : "bg-[#0d0d0d]"
        }`}
      >
        <img
          src={item.src}
          alt={item.label}
          loading="lazy"
          className="max-h-full max-w-full object-contain"
        />
      </div>
    </a>
    <div className="p-4 flex-1 flex flex-col">
      <p className="text-[10px] tracking-[0.2em] uppercase text-white/80">{item.label}</p>
      <p className="text-[9px] tracking-[0.15em] uppercase text-white/35 mt-1 flex-1">{item.meta}</p>
      <div className="flex gap-2 mt-4">
        <a
          href={item.src}
          download
          data-testid={`asset-download-${slug(item.label)}`}
          className="flex-1 text-center border border-white/30 px-3 py-2.5 text-[9px] tracking-[0.25em] uppercase hover:bg-white hover:text-black hover:border-white transition-colors duration-200"
        >
          Download
        </a>
        <a
          href={item.src}
          target="_blank"
          rel="noreferrer"
          data-testid={`asset-open-${slug(item.label)}`}
          className="px-3 py-2.5 text-[9px] tracking-[0.25em] uppercase text-white/50 border border-white/10 hover:border-white/40 hover:text-white transition-colors duration-200"
        >
          Open
        </a>
      </div>
    </div>
  </div>
);

export default function MediaKit() {
  const navigate = useNavigate();
  const [ok, setOk] = useState(false);
  const key = sessionStorage.getItem("paeon_studio_key");

  useEffect(() => {
    if (!key) {
      navigate("/studio");
      return;
    }
    api
      .get("/admin/dashboard", { headers: { "X-Admin-Token": key } })
      .then(() => setOk(true))
      .catch(() => {
        sessionStorage.removeItem("paeon_studio_key");
        navigate("/studio");
      });
  }, [key, navigate]);

  if (!ok) {
    return (
      <main className="min-h-screen bg-[#050505] text-white flex items-center justify-center">
        <p className="text-[10px] tracking-[0.35em] uppercase text-white/40 animate-pulse">Loading media kit…</p>
      </main>
    );
  }

  return (
    <main className="min-h-screen bg-[#050505] text-white px-6 md:px-12 py-12" data-testid="media-kit-page">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between border-b border-white/15 pb-8 mb-12">
          <div>
            <p className="font-serif text-4xl md:text-5xl tracking-tight">MEDIA KIT</p>
            <p className="text-[9px] tracking-[0.35em] uppercase text-white/40 mt-2">
              Every logo and graphic · click to preview · download to post
            </p>
          </div>
          <Link
            to="/studio"
            data-testid="media-kit-back-link"
            className="border border-white/30 px-5 py-3 text-[9px] tracking-[0.3em] uppercase hover:bg-white hover:text-black hover:border-white transition-colors duration-200"
          >
            Back to Studio
          </Link>
        </div>

        {GROUPS.map((g) => (
          <section key={g.title} className="mb-16" data-testid={`media-group-${slug(g.title)}`}>
            <div className="flex items-baseline gap-4 mb-5">
              <p className="text-[10px] tracking-[0.35em] uppercase text-white/70">{g.title}</p>
              <p className="text-[9px] tracking-[0.2em] uppercase text-white/30">{g.note}</p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {g.items.map((item) => (
                <AssetCard key={item.src} item={item} />
              ))}
            </div>
          </section>
        ))}
      </div>
    </main>
  );
}
